import React from 'react';
import EditButton from '../EditButton';
import DeleteButton from '../DeleteButton';
import { ButtonContainer, Wrapper } from './styled';
import { Separator } from 'Common/Components/CustomActionBar/styled';

const Actions = ({ show }) => {
  if (!show) return null;
  return (
    <Wrapper>
        <Separator />
        <ButtonContainer>
          <EditButton />
          <DeleteButton />
        </ButtonContainer>
    </Wrapper>
  );
};

export default Actions;
